import React from "react";
import "../App.css";
import { Link } from "react-router-dom";
import { BsRocketTakeoff } from "react-icons/bs";

const ComingSoon = () => {
  return (
    <>
      <div className="coming-soon">
        <div className="coming-soon-overlay"></div>
        <div className="coming-soon-content">
          <BsRocketTakeoff />
          <h2>WE ARE COMING SOON!</h2>
          <Link to="/" className="the-button-light">
            Back to Home page
          </Link>
        </div>
      </div>
    </>
  );
};

export default ComingSoon;
